import { render, staticRenderFns } from "./MyOrderNote.vue?vue&type=template&id=73903add&"
import script from "./MyOrderNote.vue?vue&type=script&lang=js&"
export * from "./MyOrderNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports